import React from 'react'

export default function Pricing() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.0459 0H5.95283C4.50019 0 3.31836 1.18188 3.31836 2.63446V21.366C3.31836 22.8186 4.50019 24 5.95283 24H18.0459C19.4984 24 20.6801 22.8186 20.6801 21.366V2.63446C20.6801 1.18188 19.4984 0 18.0459 0ZM19.6588 21.366C19.6588 22.2551 18.9353 22.9787 18.0459 22.9787H5.95283C5.06321 22.9787 4.33963 22.2551 4.33963 21.366V2.63446C4.33963 1.74485 5.06321 1.02127 5.95283 1.02127H18.0459C18.9353 1.02127 19.6588 1.74485 19.6588 2.63446V21.366Z" fill="#03555E" />
      <path d="M6.38281 8.52328H17.6169V3.06382H6.38281V8.52328ZM7.40409 4.08509H16.5956V7.50196H7.40409V4.08509Z" fill="#03555E" />
      <path d="M8.95577 13.4382H7.42383V14.4594H8.95577V13.4382Z" fill="#03555E" />
      <path d="M12.7663 13.4382H11.2344V14.4594H12.7663V13.4382Z" fill="#03555E" />
      <path d="M16.5769 13.4382H15.0449V14.4594H16.5769V13.4382Z" fill="#03555E" />
      <path d="M8.95577 16.6765H7.42383V17.6978H8.95577V16.6765Z" fill="#03555E" />
      <path d="M12.7663 16.6765H11.2344V17.6978H12.7663V16.6765Z" fill="#03555E" />
      <path d="M16.5769 16.6765H15.0449V17.6978H16.5769V16.6765Z" fill="#03555E" />
      <path d="M8.95577 19.9149H7.42383V20.9362H8.95577V19.9149Z" fill="#03555E" />
      <path d="M12.7663 19.9149H11.2344V20.9362H12.7663V19.9149Z" fill="#03555E" />
      <path d="M16.5769 19.9149H15.0449V20.9362H16.5769V19.9149Z" fill="#03555E" />
      <path d="M17.3022 10.4701H14.2383V11.4914H17.3022V10.4701Z" fill="#03555E" />
      <path d="M9.76106 10.4701H6.69727V11.4914H9.76106V10.4701Z" fill="#03555E" />
    </svg>
  )
}
